import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { Register } from './registration/register/register';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'registration' },
  { path: 'registration', component: Register },
  { path: 'registration/step1', pathMatch: 'full', redirectTo: 'registration' },
  { path: 'registration/step2', pathMatch: 'full', redirectTo: 'registration' },
  // any other url goes to the registration start, with every query param dropped
  { path: '**', canActivate: [() => inject(Router).createUrlTree(['/registration'])], component: Register },
];
